"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Clock = _interopRequireDefault(require("../../icons-react/Clock"));
var _Button = _interopRequireDefault(require("../Button"));
// icons

// components

// types

var WarnDebt = function WarnDebt(_ref) {
  var onClick = _ref.onClick,
    title = _ref.title,
    time = _ref.time,
    description = _ref.description,
    buttonLabel = _ref.buttonLabel,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(StyledWrapper, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledTextPart, null, /*#__PURE__*/_react["default"].createElement(StyledWarnTitle, null, title, /*#__PURE__*/_react["default"].createElement(StyledIcon, null), time), /*#__PURE__*/_react["default"].createElement(StyledWarnText, null, description)), /*#__PURE__*/_react["default"].createElement(StyledButton, {
    onClick: onClick,
    primary: true
  }, buttonLabel));
};
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "WarnDebt__StyledWrapper",
  componentId: "sc-1jc6n47-0"
})(["width:100%;display:flex;margin-bottom:10px;background:#fffbe5;justify-content:space-between;"]);
var StyledTextPart = _styledComponents["default"].div.withConfig({
  displayName: "WarnDebt__StyledTextPart",
  componentId: "sc-1jc6n47-1"
})(["margin:8px 0px 16px 16px;> span{font-style:normal;}"]);
var StyledWarnTitle = _styledComponents["default"].span.withConfig({
  displayName: "WarnDebt__StyledWarnTitle",
  componentId: "sc-1jc6n47-2"
})(["font-weight:500;font-size:18px;line-height:22px;display:block;margin-bottom:4px;"]);
var StyledWarnText = _styledComponents["default"].span.withConfig({
  displayName: "WarnDebt__StyledWarnText",
  componentId: "sc-1jc6n47-3"
})(["font-size:14px;line-height:16px;"]);
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "WarnDebt__StyledButton",
  componentId: "sc-1jc6n47-4"
})(["margin:13px 16px 0px 8px;"]);
var StyledIcon = (0, _styledComponents["default"])(_Clock["default"]).withConfig({
  displayName: "WarnDebt__StyledIcon",
  componentId: "sc-1jc6n47-5"
})(["vertical-align:middle;margin:0 2px 2px;stroke:black;width:16px;path{stroke-width:1;fill:#f8e71c;}"]);
var _default = exports["default"] = WarnDebt;